module.exports = __webpack_public_path__ + "static/img/Qfirst.ae52a757.jpeg";